import { render, staticRenderFns } from "./casa.vue?vue&type=template&id=73a3ded2&"
import script from "./casa.vue?vue&type=script&lang=js&"
export * from "./casa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports